/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Button, Input, Rate, Space } from 'antd';
import { useParams } from 'react-router';
import { useHeroApiService } from '@core/hooks';
import { LocalLocation } from '@core/models';
import LoadableContainer from '@components/LoadableContainer';
import { CheckOutlined, LoadingOutlined } from '@ant-design/icons';
import { NEGATIVE_RATE_CEILING } from '@constants/rate-conversion';
import { BRAND_NAME, BRAND_URL } from '@constants/brand';
import { useBreakpoint } from '@core/hooks/useBreakpoint';
import { SnackbarItem, enqueueNotification } from '@core/features';
import { useAppDispatch } from '@core/configureStore';

type Props = {};

const RenderFinishedContent = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}>
      <CheckOutlined style={{ fontSize: 50, color: 'green' }} />
      <div style={{ marginTop: 30, textAlign: 'center', width: '70%' }}>
        <h1>Submitted</h1>
        <p>Thank you for spending your time to leave us a review</p>
      </div>
    </div>
  );
};

const AnonymousRequestCallbackScreen = (props: Props) => {
  const breakpoint = useBreakpoint();
  const dispatch = useAppDispatch();
  const heroApiService = useHeroApiService();
  const [loading, setLoading] = useState<boolean>(false);
  const [placeId, setPlaceId] = useState('');
  const [selectedRate, setSelectedRate] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [location, setLocation] = useState<LocalLocation | null>(null);
  const [isFetchingLocation, setIsFetchingLocation] = useState<boolean>(true);
  const [isFinished, setIsFinished] = useState<boolean>(false);
  const { locationId } = useParams<{
    locationId: string;
  }>();

  const submitReview = async () => {
    try {
      setLoading(true);
      await heroApiService.saveReviewAnonymous({
        locationId,
        comment: feedback,
        emailAddress: email,
        fullName: name,
        rating: selectedRate,
      });
      setLoading(false);
    } catch (error: any) {
      dispatch(
        enqueueNotification({
          name: 'Failed to submit review',
          description: 'There was error submitting review. Please try again',
          type: 'Error',
        } as SnackbarItem)
      );
      setLoading(false);
      throw new Error(error);
    }
  };

  const submitNegativeFeedback = async () => {
    await submitReview();
    setIsFinished(true);
  };

  const continueGoogleReview = async (location: any) => {
    if (!location) return;
    await submitReview();
    window.location.replace(`https://search.google.com/local/writereview?placeid=${placeId}`);
  };

  useEffect(() => {
    const initLocation = async () => {
      setIsFetchingLocation(true);
      if (locationId) {
        const res = await heroApiService.getLocationById(locationId);
        if (res && res.place_id) {
          setPlaceId(res.place_id);
        } else {
          const placeId = await heroApiService.getLocationPlaceId(locationId);
          setPlaceId(placeId);
        }
        setLocation(res);
        setIsFetchingLocation(false);
      }
    };
    initLocation();
  }, [locationId]);

  return (
    <div
      style={{
        background:
          "url('https://media.istockphoto.com/id/1010335754/photo/photo-blurred-of-coffee-shop-or-modern-library-abstract-bokeh-light.jpg?b=1&s=170667a&w=0&k=20&c=dtuA7ceXXGA8rQWB35shXNPcHPNyWON27plGOLHY6LQ=')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
      }}>
      <div
        style={{
          backgroundColor: 'white',
          padding: '50px 30px',
          boxShadow:
            'box-shadow: box-shadow: rgba(255, 255, 255, 0.1) 0px 1px 1px 0px inset, rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;',
          height: 'fit-content',
          marginTop: 30,
          width: !breakpoint.isDesktop ? 400 : '100%',
          justifyContent: 'center',
          display: 'flex',
        }}>
        <Space direction="vertical" style={{ justifyContent: 'center' }}>
          <LoadableContainer isLoading={isFinished} loadComponent={<RenderFinishedContent />}>
            <LoadableContainer
              isLoading={isFetchingLocation}
              loadComponent={
                <div style={{ textAlign: 'center', fontSize: 30 }}>
                  <LoadingOutlined />
                </div>
              }>
              <React.Fragment>
                <div style={{ textAlign: 'center' }}>
                  <h2>Review request from</h2>
                  <span style={{ fontSize: 30 }}>{location?.title}</span>
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Rate
                      style={{ fontSize: 40 }}
                      onChange={setSelectedRate}
                      value={selectedRate}
                    />
                  </div>
                  <Space
                    direction="vertical"
                    style={{ justifyContent: 'center', marginTop: 30, textAlign: 'left' }}>
                    {selectedRate && selectedRate <= NEGATIVE_RATE_CEILING ? (
                      <React.Fragment>
                        <h4>Name</h4>
                        <Input
                          value={name}
                          style={{ border: 'none', padding: 0 }}
                          onChange={e => setName(e.target.value)}
                          placeholder="Enter your name"
                        />
                        <br />
                        <h4>Email address (Optional)</h4>
                        <Input
                          value={email}
                          style={{ border: 'none', padding: 0 }}
                          onChange={e => setEmail(e.target.value)}
                          placeholder="Enter your email"
                        />
                        <br />
                        <h4>Feedback</h4>
                        <Input.TextArea
                          style={{ border: 'none', padding: 0 }}
                          autoSize={{ minRows: 5 }}
                          contentEditable={true}
                          value={feedback}
                          onChange={e => setFeedback(e.target.value)}
                          placeholder="Enter your feedback"
                        />
                        <Button
                          loading={loading}
                          disabled={selectedRate === 0}
                          onClick={submitNegativeFeedback}
                          type={'primary'}
                          style={{ width: 250 }}>
                          Submit review
                        </Button>
                      </React.Fragment>
                    ) : (
                      <Button
                        disabled={!selectedRate}
                        onClick={continueGoogleReview}
                        type={'primary'}
                        style={{ width: 250 }}>
                        Continue
                      </Button>
                    )}
                    <a
                      href={BRAND_URL}
                      style={{ color: '#1677ff' }}
                      target="_blank"
                      rel="noreferrer">
                      powered by {BRAND_NAME}
                    </a>
                  </Space>
                </div>
              </React.Fragment>
            </LoadableContainer>
          </LoadableContainer>
        </Space>
      </div>
    </div>
  );
};

export default AnonymousRequestCallbackScreen;
